import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Input } from 'widget/components';
import { useWidgetContext } from 'widget/widget-context';

const Name = () => {
  const { widget } = useWidgetContext();

  const [field, meta, helpers] = useField<string>('name');
  const { t } = useTranslation();

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      isValid={isValid}
      onChange={helpers.setValue}
      placeholder={`${t`Name`}${widget.is_name ? '*' : ''}`}
      style={{ marginBottom: 16 }}
    />
  );
};

export default Name;
